import { LeafletPixiContext } from "./useLeafletPixi";
import { useEffect, useState } from "react";
import { useTypedSelector } from "@hooks/useTypedSelector";
import Logger from "../../../../utils/logger";
import * as L from "leaflet";
import { latLngBounds } from "leaflet";

const log = Logger.getLogger("wms")
export default function (pixiContext: LeafletPixiContext | undefined) {
    const { toggles } = useTypedSelector(state => state.mapTabSettings)
    const [currentWmsLayer, setWmsLayer] = useState<L.TileLayer.WMS>()
    useEffect(() => {
        if (pixiContext) {
            log.debug("Rosreestr layer enabled", toggles.rosreestr)
            if (toggles.rosreestr) {
                if (!currentWmsLayer) {
                    const wmsLayer = L.tileLayer.wms("https://testgeoserver.infobis.ru/geoserver/wms", {
                        tileSize: 1024,
                        opacity: 0.6,
                        bounds: latLngBounds([-20037508.34, -20037508.34], [20037508.34, 20037508.34]),
                        layers: "rosreestr",
                        format: "image/png",
                        transparent: true
                    })
                    wmsLayer.addTo(pixiContext.map)
                    setWmsLayer(wmsLayer)
                } else {
                    log.debug("Rosreestr WMS layer already exist...", currentWmsLayer)
                }
            } else {
                if (currentWmsLayer) {
                    log.debug("Remove rosreestr WMS layer...")
                    pixiContext.map.removeLayer(currentWmsLayer)
                }
                setWmsLayer(undefined)
            }
        }
    }, [pixiContext, toggles.rosreestr])
}